{
  "zh-CN": {
    "appModal": {
      "messages": {
        "confirm": {
          "dirty": "你有未保存的更改，关闭后将会丢失。"
        }
      }
    }
  }
}
